module.exports = __webpack_public_path__ + "client side.svg?c427ac5efb320d2820b659e33acd3a1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client side.svg
// module id = 28
// module chunks = 0